
<div class="customer-favorites">
  <h1>Mes favoris à louer ({{ (myRentCars$  | async)?.length}})</h1>

  <div class="buttons-section">
  </div>
  <!--
  <div class="cars-section" *ngIf="((myBuyCars$  | async) != undefined )">
    <div *ngFor="let car of (myBuyCars$  | async)!; index as i" id="{{car.id}}" class="car-section">

      <app-car-card
        [car]="car"
        [fetchingResults]="(fetchingResults$ | async)!"
        [carImagesFolder]="(carImagesFolders$ | async)!.get(car.id)!">
      </app-car-card>
    </div>
  </div> -->

  @if (((myRentCars$  | async) !== undefined )) {
    <div>
      <app-car-card-list
        [fetchingResults]="(fetchingResults$ | async)!"
        [cars]="(myRentCars$ | async)!"
        [businessLine]="businessLine!"
        >
      </app-car-card-list>
    </div>
  }
  <!--
  <app-alerts
    [alerts]="(myProfile$ | async)!.alerts"
    >
  </app-alerts> -->
</div>

